import { render, staticRenderFns } from "./BallCustom.vue?vue&type=template&id=bf790a72&"
import script from "./BallCustom.vue?vue&type=script&lang=js&"
export * from "./BallCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports